import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson15: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV />
      <div className="self-stretch flex flex-row items-center justify-between">
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson14"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Back
            </b>
          </div>
        </a>
        <div className="flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[120%]">
            Portfolio Management
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson16"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Next
            </b>
          </div>
        </a>
      </div>
      <div className="flex flex-col items-center justify-center gap-[7.5rem] w-[92%] mr-[4%] max-w-[110rem] text-justify text-white font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>What is a Crypto Portfolio?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                A crypto portfolio refers to an investor's online inventory of
                cryptocurrency investments.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                For example, if you own $5000 in Bitcoin, and Ethereum, your
                crypto portfolio is valued at $10,000.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[4.63rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem]">
              <b>
                <span>Maintaining a Balance Portfolio</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Now that you have created your exchange account and learned
                    how to start trading, it is important to consider balancing
                    your portfolio in order to minimize risks.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>There are three key factors to do so:</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <span>Diversification</span>
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <span>Outperformers</span>
                  </span>
                </span>
              </li>
              <li>
                <span>
                  <span>
                    <span>Rebalancing</span>
                  </span>
                </span>
              </li>
            </ul>
          </div>
          <img
            className="relative w-[42.81rem] h-[23rem] object-cover"
            alt=""
            src="/i61@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[4.63rem] text-[1.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Diversification</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    The first and main purpose of a balanced crypto portfolio is
                    diversification.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b className="font-dm-sans">Diversification</b>
                  <span>
                    {" "}
                    is investing into different coins and tokens to hedge
                    against their price changes
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[17.63rem] object-cover"
            alt=""
            src="/image-27@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Benefits of Diversification</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Provide your portfolio with non-correlated cryptocurrencies so
                  that they can offset.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Some cryptos might tank while another completed unrelated in
                  terms of solutions and mission can hold steady. This can be
                  very important to prevent your portfolio from completely
                  tanking.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Limit extreme outcomes</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  If one of your crypto holds fail at least you are diversified
                  enough to prevent your entire portfolio from being wiped out.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Allow exposure to better potential outperformers</span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Encourages market research and knowledge within the space.
                  Understanding market cap and crypto correlations are important
                  to diversifying your portfolio.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">Diversification Example - XRP</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  {`In this case, we will look at XRP (Ripple). In the past two years, XRP has seen some major volatility. In November of 2020, Fred decided to begin his cryptocurrency journey and put all of his savings of $50,000 USD into XRP for the long term. Just the following month in December of 2020, XRP (Ripple) faced a `}
                </span>
              </span>
            </span>
            <a
              className="text-[inherit]"
              href="https://www.protocol.com/fintech/ripple-cryptocurrency-xrp-sec-bitcoin"
              target="_blank"
            >
              <span>
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      $1.3 billion lawsuit
                    </span>
                  </span>
                </span>
              </span>
            </a>
            <span>
              <span>
                <span>
                  {" "}
                  from the SEC (Securities and Exchange Commission) for an
                  unregistered securities offering.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>{`If we refer back to our `}</span>
              </span>
            </span>
            <a
              className="text-[inherit]"
              href="https://www.notion.so/6d4e620997334228b6ca6d0ed5b751a5?pvs=21"
              target="_blank"
            >
              <span>
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      Introduction To Cryptocurrency guide
                    </span>
                  </span>
                </span>
              </span>
            </a>
            <span>
              <span>
                <span>{` 1 of the 3 main things that give a cryptocurrency demand is `}</span>
                <b className="font-dm-sans">{`perceived value. `}</b>
                <span className="font-dm-sans">
                  This negative news shook XRP's market and the coin's market
                  price tanked in December after this news became public. Fred's
                  portfolio of $50,000 was instantly reduced and would not have
                  recovered until 5-6 months later if he was confident enough in
                  XRP's (Ripple) ability in recovering to hold through the lows.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span className="font-dm-sans">&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span className="font-dm-sans">
                  Cryptocurrencies are still largely unregulated and laws are
                  still being created regarding them. Holding onto just one coin
                  makes you as an investor completely vulnerable to any small
                  news that impacts the crypto you are invested in. A smart
                  investor will never pin their entire portfolio on the
                  performance of just one coin. Diversity is key!
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Diversify and Hedge</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Making sure you make the most of your trading means never
                putting all your eggs in one basket. If you put all your money
                into one idea, you're setting yourself up for a big loss.
                Remember to diversify your investments—across both industry
                sector as well as market capitalization and geographic region.
                Not only does this help you manage your risk, but it also opens
                you up to more opportunities.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                You may also find yourself needing to hedge your position.
                Consider a stock position when the results are due. You may
                consider taking the opposite position through options, which can
                help protect your position. When trading activity subsides, you
                can then unwind the hedge.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[4.63rem] text-[1.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Outperformers</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Outperformers refers to cryptocurrencies in your portfolio
                  that are doing better than any others you have within your
                  crypto holdings.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The second purpose of having a balanced crypto portfolio is it
                  allows for investors to be potentially exposed to more
                  outperformers than usual. By spreading your investments out
                  you not only spread your risk out but also your portfolio
                  potential.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[22.5rem] object-cover"
            alt=""
            src="/i62@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          {`When building your crypto portfolio always look for outperformers. As you do your own research, look for those projects that have the potential to solve real-world problems. A good example of this can be `}
          <a
            className="text-[inherit]"
            href="https://www.gemini.com/cryptopedia/what-is-chainlink-and-how-does-it-work#section-chainlink-oracles-bridge-the-on-and-off-chain-chasm"
            target="_blank"
          >
            <span className="[text-decoration:underline]">
              Chainlink's solution
            </span>
          </a>{" "}
          to the problem of decentralized applications not being able to
          natively interact with data off of the blockchain.
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[4.63rem] text-[1.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Rebalancing</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    The third purpose of a balanced and diversified portfolio is
                    the ability to effectively rebalance. This allows you to
                    effectively use gains from your outperforming cryptos to
                    fund the rest of your portfolio.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b className="font-dm-sans">Rebalancing</b>
                  <span>
                    {" "}
                    is realigning your crypto asset percentage weightings within
                    your investment portfolio to rebalance and spread out risks.
                    Look at the example below for a better understanding.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>{`Let's say you are invested in 3 coins: A, B, and C. You have 50% of your portfolio in Coin A and 25% each in B and C. If coin A outperforms the rest of your coins and takes over 60% of your portfolio you will be able to `}</span>
                  <b className="font-dm-sans">rebalance</b>
                  <span className="font-dm-sans"> your portfolio.</span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[26.5rem] object-cover"
            alt=""
            src="/i63@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">{`Rebalancing just means you will sell off a portion of your Coin A's profits and buy more Coin B & C. In doing this you can get back to that 50/25/25 split or can even incorporate a new strategy like 25/25/25/25 split evenly across your entire portfolio.`}</div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Methods of Managing Your Portfolio</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                A balanced portfolio will lead to a sustainable portfolio.
                Investing in any digital asset can seem very intimidating
                especially with some having intricate technologies behind it.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Make sure you take time to learn and fundamentally analyze any
                cryptocurrency you are looking to invest in first. When you are
                ready to build your portfolio you can follow a few foundations
                that we think are crucial in reaching that well-managed balanced
                portfolio.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Rationality</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Exit Strategies</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Use an Overall Crypto Portfolio Tracker</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>DCA (Dollar Cost Averaging)</span>
              </span>
            </li>
            <li>
              <span>
                <span>Diversification</span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[4.63rem] text-[1.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Rationality</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Crypto prices are extremely volatile, with wild swings to both
                  the upside and downside. Additionally, blockchain technology
                  is a relatively new technology and truly exciting to see the
                  possible implementations within modern society. However, it is
                  important to keep your emotions in check and keep a rational
                  balance.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Fear of missing out is one of the major reasons why all
                  traders fail at portfolio management. When buying any rising
                  asset, emotions become even more dangerous. If the market
                  suddenly drops 30% many beginner crypto traders get very
                  anxious because they are uncertain if that drop can go
                  further. This in combination with FOMO can lead to irrational
                  decisions.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[30.5rem] object-cover"
            alt=""
            src="/i64@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          Any successful crypto investor or trader is always rational about
          their strategies and goals. They understand that market entry
          opportunities will always be there. Reinforcement of fundamentals like
          technical analysis can help separate your trading from your emotions.
          It can also help you hone more disciplined trading strategies and
          skills. Just remember to have a proper strategy and stick with it.
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[4.63rem] text-[1.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Exit Strategies</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Every trader should have an exit strategy for any of their
                  trades plans. The human brain works in amazing ways.
                  Neurotransmitters in our brain acts as a messenger between our
                  nerve cells. Whenever we experience pleasurable moments
                  (milestones, learning, achievements, happiness, etc) our brain
                  releases dopamine, which makes us feel good about our
                  decisions and the moment.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[17.63rem] object-cover"
            alt=""
            src="/i65@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            Many of you have experienced this before! Applying it to investing
            or trading can be very dangerous as it can incite false confidence.
            Without a proper exit plan and strategy traders can be filled with
            overconfidence that comes from positive market trends. Good markets
            can lead to positive returns which releases dopamine making us much
            more likely to hold onto the trade.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            In some cases, the overconfidence received from this can be
            brainwashing. Market "trends" are categorized as trends for one
            simple reason: All trends come to an end no matter how long they may
            be going on. It's a wonderful time for traders when strong positive
            market trends are in place however trends become oversaturated and
            it begins to alter.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            A test of a true crypto investor/trader is how well he/she can adapt
            to these changes. The smart approach is building an exit plan and
            strategy before entering any trades. This way they have preset
            limits to hold themselves to minimize their risk by setting a price
            they will exit no matter what and a price they will take profits.
            Sticking to your exit strategy will instill the discipline you need
            to become a successful crypto trader.
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[4.63rem] text-[1.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Crypto Portfolio Trackers</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>{`While building your crypto portfolio trading with us here at Secured you will create numerous wallets, exchange accounts, etc. This can get overwhelming very quickly having to remember what crypto you have in this wallet or exchange. Well, the crypto industry has one of the biggest advantages already by having a decentralized nature. `}</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  A crypto portfolio tracker is a great solution to this
                  problem. It allows you to take advantage of the decentralized
                  nature of the industry. It reads all of your wallets/exchanges
                  data and aggregates all of that data into one dashboard for
                  you! They accurately let you see how much of each crypto you
                  have in your overall portfolio rather than per exchange or
                  wallet. This tool can be used in accordance with our other
                  benefits of a balanced portfolio.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[28.5rem] object-cover"
            alt=""
            src="/i66@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            <b>Some benefits of a cryptocurrency portfolio tracker are:</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-inherit pl-[1.32rem]">
            <li className="mb-[false]">
              <span>
                If any of your cryptocurrency holdings increase it will show in
                your overall crypto portfolio
              </span>
            </li>
            <li className="mb-[false]">
              <span>
                Allows you to make more informed decisions in rebalancing,
                taxes, exit strategies, etc.
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-inherit pl-[1.32rem]">
            <li className="mb-[false]">
              <span>
                Ability to trade directly on exchanges (Most portfolio trackers)
              </span>
            </li>
            <li className="mb-[false]">
              <span>
                Convenience without having to login to a separate exchange
                account to trade
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-inherit pl-[1.32rem]">
            <li className="mb-[false]">
              <span>Tax planning and preparation</span>
            </li>
            <li className="mb-[false]">
              <span>
                In the US, crypto holdings are treated as property. Sales of
                crypto trigger taxable events.
              </span>
            </li>
            <li>
              <span>
                Neatly organizes transactions for record-keeping tax purposes.
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Notable Crypto Portfolio Trackers:</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <a
                className="text-[inherit]"
                href="https://coinstats.app/"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      Coinstats
                    </span>
                  </span>
                </span>
              </a>
              <span>
                <span> (Best for tracking large crypto portfolios)</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <a
                className="text-[inherit]"
                href="https://coinmarketcap.com/portfolio-tracker/"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      CoinMarketCap
                    </span>
                  </span>
                </span>
              </a>
              <span>
                <span> (Best for in-depth trade analysis)</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <a
                className="text-[inherit]"
                href="https://www.kubera.com/"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">Kubera</span>
                  </span>
                </span>
              </a>
              <span>
                <span>
                  {" "}
                  (Paid but voted best all in one financial tracking -
                  investments, real estate, loans, etc)
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <a
                className="text-[inherit]"
                href="https://coinmarketman.com/"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      Coin Market Manager
                    </span>
                  </span>
                </span>
              </a>
              <span>
                <span> (Clean UI and supports all major exchanges)</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                All of the above have their own unique pros and cons. Please
                look into each of them and what benefits fit your personal
                situation the best.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                When selecting your crypto portfolio tracker make sure to look
                for these things:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 text-[1.56rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  {`Safety & Security (2FA options, no past breaches, etc)`}
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Clean User Interface</span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Number of Exchanges/Wallets and coins supported (Not all
                  trackers support everything)
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[4.63rem] text-[1.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Dollar Cost Averaging</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  New investors probably won't have large sums of money to dump
                  into a crypto portfolio. This is why regular small investments
                  from your income cash flow are one the best ways to start
                  building your portfolio. This is where Dollar Cost Averaging
                  comes into play and solidifies itself as one of the best
                  trading strategies in both bull and bear markets.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Doller cost averaging refers to the automatic system of making
                  fixed dollar amount investments regardless of the crypto's
                  price. This allows for your portfolio to be balanced because
                  you make fixed investments at all points of a crypto's price.
                  Choosing the perfect entry point can be a tough task. This
                  eliminates any anxiety of imperfect timing entering into
                  plays.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[25.63rem] object-cover"
            alt=""
            src="/i67@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          Review the image shown above and make sure you fully understand it. In
          the example, instead of locking in an average unit cost DCA allowed
          for that investor to spread their costs out. In the end, they received
          a much better percentage return on their investments.
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[4.63rem] text-[1.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Diversification</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  We are sure you have all heard the famous saying to never put
                  all your eggs in one basket. That is exactly what we are
                  referring to when we say diversify your portfolio. This is one
                  of the best portfolio management strategies especially in
                  crypto where diversification can be hard.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  A lot of cryptocurrencies are correlated to each other in one
                  way or the other. So it may be tough figuring out the best
                  approach to diversify. However, while challenging it is still
                  very possible to do with enough time and research into your
                  own portfolio's financial needs.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[26.69rem] object-cover"
            alt=""
            src="/i68@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            A few things to look for in cryptocurrencies when diversifying and
            planning the basis for your portfolio are:
          </p>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 font-inherit text-inherit pl-[1.32rem]">
            <li className="mb-[false]">
              Ask yourself: What cryptocurrencies have large market
              capitalizations which can indicate a strong future?
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 font-inherit text-inherit pl-[1.32rem]">
            <li className="mb-[false]">
              Look at investing into stablecoins you can lend at a high-interest
              rate. This will allow you to earn interest on that percentage of
              your overall portfolio even in a bearish market.
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 font-inherit text-inherit pl-[1.32rem]">
            <li className="mb-[false]">
              Small-Growth Projects - although the performance of these can be
              linked to broader crypto market any additional growth can benefit
              your overall portfolio.
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 font-inherit text-inherit pl-[1.32rem]">
            <li>
              Look into the fundamentals of the native token behind
              cryptocurrencies. This way you can attempt to get a better
              understanding of the value it can bring to the crypto industry.
            </li>
          </ul>
        </div>
      </div>
      <a className="w-full mb-[6rem] rounded-32xl bg-gainsboro-200 box-border flex flex-row items-center justify-between py-[0.75rem] px-[0rem] max-w-[25rem] text-center text-[2.81rem] border-[1px] border-solid border-gray-300"
        href="/lesson16">
        <div className="w-full">
          <b className="inline-block flex-1 w-full relative text-center max-md:pb-[0.8rem]">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson15;
